/**
 * Things a support message can name that the inbox can show on the spot: an
 * order number, say. The app registers each kind — how it is written
 * (`pattern`), how to look it up (`resolve(token) → data | null`) and what
 * to show (`Card({ data, token })`) — and the chat bubble turns every match
 * it can resolve into a chip that opens the card on hover (or a tap).
 *
 *   registerReference({ id: "order", pattern: /#?\b[0-9A-F]{8}\b/g, resolve, Card })
 */
const references = []

export function registerReference(reference) {
  if (!reference?.id || !reference.pattern || !reference.resolve || !reference.Card) return
  const at = references.findIndex((r) => r.id === reference.id)
  if (at >= 0) references[at] = reference
  else references.push(reference)
}

export const getReferences = () => references

/** A `g` copy of the reference's pattern, for scanning. */
export const patternOf = (reference) => new RegExp(reference.pattern.source, reference.pattern.flags.includes("g") ? reference.pattern.flags : reference.pattern.flags + "g")

/**
 * What the inbox can show about the customer behind a ticket, under the
 * conversation: their orders, their transactions — whatever the app has.
 * Each is a button in the ticket's Actions; the panel gets
 * `{ customer: { email, user }, ticket }` (`user` is the platform account
 * matched by the email, or null).
 *
 *   registerCustomerPanel({ id: "orders", label: "Orders", Panel })
 */
const customerPanels = []

export function registerCustomerPanel(panel) {
  if (!panel?.id || !panel.label || !panel.Panel) return
  const at = customerPanels.findIndex((p) => p.id === panel.id)
  if (at >= 0) customerPanels[at] = panel
  else customerPanels.push(panel)
}

export const getCustomerPanels = () => customerPanels
